import { IPaymentConfirmation } from "../../../model/payment/PaymentConfirmation";
import { DateService } from "../../../service/DateService";
import { PaymentConfirmationConstants } from "../../../common/Constants";
import NumberFormatter from "../../../model/common/NumberFormatter";

export interface TPaymentConfirmationPresentationModel {
  id: number;
  type: string;
  processingDate: string;
  amount: string;
  description: string;
  senderAccount: string;
  receiverAccount: string;
  senderName?: string;
  receiverName?: string;
  sourceCurrency?: string;
  destinationCurrency?: string;
  paymentReference?: string;
  instant?: string;
  urgent?: string;
  taxPayerId?: string;
  paymentType?: string;
  revenueType?: string;
  taxPeriodFrom?: string;
  taxPeriodTo?: string;
  municipality?: string;
  budgetaryUnit?: string;
  taxRefNumber?: string;
  bicCode?: string;
  bankName?: string;
  address?: string;
  address2?: string;
  coverageAmount?: string;
  coverageCurrency?: string;
  expensesBaredBy?: string;
  paymentPurpose?: string;
  buyAmount?: string;
  coverageAccount?: string;
  abroadExecutionTime?: string;
  paymentPurposeVisible?: boolean;
  paymentReferenceVisible?: boolean;
  instantPaymentVisible?: boolean;
}

const PaymentConfirmationPresentationModel = (
  data: IPaymentConfirmation
): TPaymentConfirmationPresentationModel => {
  const processingDate = DateService().formatToLocalTime(data.processingDate);
  const amount = NumberFormatter().format(
    data.amount,
    PaymentConfirmationConstants.AMOUNT_DECIMAL_PRECISION
  );
  const taxPeriodFrom = data.taxPeriodFrom
    ? DateService().formatWithoutTime(data.taxPeriodFrom)
    : undefined;
  const taxPeriodTo = data.taxPeriodTo
    ? DateService().formatWithoutTime(data.taxPeriodTo)
    : undefined;
  const coverageAmount = data.coverageAmount
    ? NumberFormatter().format(
        data.coverageAmount,
        PaymentConfirmationConstants.AMOUNT_DECIMAL_PRECISION
      )
    : undefined;
  const buyAmount = data.buyAmount
    ? NumberFormatter().format(
        data.buyAmount,
        PaymentConfirmationConstants.AMOUNT_DECIMAL_PRECISION
      )
    : undefined;

  return {
    ...data,
    processingDate,
    amount,
    taxPeriodFrom,
    taxPeriodTo,
    coverageAmount,
    buyAmount,
    paymentPurposeVisible: data.paymentPurposeVisible(),
    paymentReferenceVisible: data.paymentReferenceVisible(),
    instantPaymentVisible: data.instantPaymentVisible()
  };
};

export default PaymentConfirmationPresentationModel;
